<template>
  <IconProfile
    :color-profile="mappingProfileThis?.color"
    :initials="mappingProfileThis?.initials"
  />
</template>

<script setup lang="ts">
import { inject, ref } from 'vue';

import IconProfile from '@/components/icons/IconProfile.vue';
import { SettingsProfile } from '@/types/components';
import { ij_mappingProfileThis } from '@/utils/injectionKeys';

const mappingProfileThis = inject(
  ij_mappingProfileThis,
  ref({} as SettingsProfile)
);
</script>

<style lang="scss" scoped></style>
